export default "__VITE_ASSET__BfRZmTRH__"